import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface DocumentTemplateCategory {
  categoryId: string;
  projectId: string;
  name: string;
  sortOrder: number;
  templates: DocumentTemplate[];
}

export interface DocumentTemplate {
  templateId: string;
  projectId: string;
  categoryId: string;
  name: string;
  description: string | null;
  content: unknown;
  sortOrder: number;
  createdBy: string;
  creator: { id: string; name: string; avatarUrl: string | null };
}

function base(projectId: string) {
  return `/projects/${projectId}/document-templates`;
}

export async function fetchTemplatesWithCategories(projectId: string) {
  const res = await api.get<ApiResponse<DocumentTemplateCategory[]>>(base(projectId));
  return res.data.data!;
}

export async function createCategory(projectId: string, data: { name: string }) {
  const res = await api.post<ApiResponse<DocumentTemplateCategory>>(
    `${base(projectId)}/categories`,
    data,
  );
  return res.data.data!;
}

export async function createTemplate(
  projectId: string,
  data: { categoryId: string; name: string; description?: string; content?: unknown },
) {
  const res = await api.post<ApiResponse<DocumentTemplate>>(base(projectId), data);
  return res.data.data!;
}

export async function updateTemplate(
  projectId: string,
  templateId: string,
  data: { name?: string; description?: string; content?: unknown },
) {
  const res = await api.put<ApiResponse<DocumentTemplate>>(
    `${base(projectId)}/${templateId}`,
    data,
  );
  return res.data.data!;
}

export async function deleteTemplate(projectId: string, templateId: string) {
  await api.delete(`${base(projectId)}/${templateId}`);
}
